export class AreaGateLogSelection {
  dateFrom: string;
  dateUntil: string;
  type: string;

  constructor(selection?: Partial<AreaGateLogSelection>) {
    if (selection != null) {
      this.dateFrom = selection.dateFrom;
      this.dateUntil = selection.dateUntil;
      this.type = selection.type;
    }
  }
}

export class AreaGateLogRepresentation {

  id: number;
  date: string;
  gate: string;
  direction: string;
  event: string;
  resourceId: string;

  constructor(representation?: Partial<AreaGateLogRepresentation>) {
    if (representation != null) {
      this.id = representation.id;
      this.date = representation.date;
      this.gate = representation.gate;
      this.direction = representation.direction;
      this.event = representation.event;
      this.resourceId = representation.resourceId;
    }
  }

}
